import { Avatar } from "primereact/avatar";
import { Skeleton } from "primereact/skeleton";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { useParams } from "react-router-dom";

const CommentList = ({
  count,
  selected,
  hide,
  loading,
  data,
  formatDateTime,
  hasMore,
  fetchNextPage,
}) => {
  const { id } = useParams();

  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0]?.charAt(0) || "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const role = {
    GXM_ADMIN: "GXM Admin",
    CUSTOMER: "Customer",
    LSP_USER: "Local Team",
    GXM_USER: "GXM User",
    GXM_MANAGER: "GXM Manager",
    LSP_MANAGER: "Local Team Manager",
    CUSTOMER_MANAGER: "Customer Manager",
  };

  const loadcount = Number(selected.comment_count);
  const loaderCount = (loadcount > 3 ? 5 : loadcount) || 1;

  return (
    <div id="comment-scroll-wrapper" className="comment-scroll-wrapper">
      <div className="comment-context-header">
        <p>Comments ({selected.comment_count || count})</p>
        <i
          className="pi pi-times"
          style={{ cursor: "pointer" }}
          onClick={hide}
        />
      </div>

      {data?.length > 0 && (
        <InfiniteScroll
          dataLength={data.length}
          next={fetchNextPage}
          hasMore={hasMore}
          loader={
            <div className="py-3 text-center">
              <i className="pi pi-spin pi-spinner mr-2"></i>Loading more
              comments...
            </div>
          }
          scrollableTarget="comment-scroll-wrapper"
        >
          {data.map((item) => {
            const conversation = item?.is_public ? "public" : "internal";
            const commentType = item?.commentType || "TASK"; // Default to "TASK" if commentType is undefined
            return (
              <div className="pt-4" key={item.id}>
                <div className="flex gap-3">
                  <div className="flex-shrink-0">
                    <Avatar
                      label={getInitials(
                        `${item?.userData?.first_name} ${item?.userData?.last_name}`,
                      )}
                      shape="circle"
                      className="avatar"
                      size="large"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="modal-comment-text">
                      {`Comment added by ${item?.userData?.first_name} ${item?.userData?.last_name} (${role[item?.userData?.role]})`}
                    </p>
                    <p className="modal-comment-sub-text mt-2 mb-4">
                      {formatDateTime(item.createdAt)}
                    </p>
                    <Link
                      to={`/process/${id}/conversations/${conversation}?commentId=${item.id}&commentType=${commentType}`}
                      className="comment-list-link"
                    >
                      View in Conversation
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </InfiniteScroll>
      )}

      {loading &&
        Array(Number(loaderCount))
          .fill()
          .map((_, i) => (
            <div className="pt-4" key={i}>
              <div className="flex gap-3">
                <div className="flex-shrink-0">
                  <Skeleton shape="circle" size="3rem" className="mr-2" />
                </div>
                <div className="flex-1 min-w-0">
                  <Skeleton className="mb-1" />
                  <Skeleton className="mb-1 mt-2" />
                  <Skeleton className="mb-1" />
                </div>
              </div>
            </div>
          ))}
    </div>
  );
};

export default CommentList;
